module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_04-7e46fc9f8a0961c2745ce6e278ade618.png";